import React from 'react';
import { useTranslator } from '../components/i18n/useTranslator';
import { FormText } from '@milanote/roma';

const AuthFormDisclaimerSection = () => {
    const translate = useTranslator('auth', 'disclaimer');

    return (
        <FormText size="sm" color="quaternary" align="center">
            {translate('text', undefined, {
                components: {
                    termsLink: <a href="https://policies.google.com/terms" />,
                    privacyLink: <a href="https://policies.google.com/privacy" />,
                },
            })}
        </FormText>
    );
};

export default AuthFormDisclaimerSection;
